export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1607861884586-c7cfaed16290?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxldmVudCUyMHdhcm0lMjBzdHJpbmclMjBsaWdodHMlMjB3ZWRkaW5nfGVufDB8fHx8MTc5MTM4NjQ4OXww&ixlib=rb-4.1.0&q=85",
  festoon: "https://images.unsplash.com/photo-1624067078399-be29c52a2b12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxldmVudCUyMHdhcm0lMjBzdHJpbmclMjBsaWdodHMlMjB3ZWRkaW5nfGVufDB8fHx8MTc5MTM4NjQ4OXww&ixlib=rb-4.1.0&q=85",
  fairyCanopy: "https://images.unsplash.com/photo-1723832348105-2e69f948135a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxldmVudCUyMHdhcm0lMjBzdHJpbmclMjBsaWdodHMlMjB3ZWRkaW5nfGVufDB8fHx8MTc5MTM4NjQ4OXww&ixlib=rb-4.1.0&q=85",
  courtyard: "https://images.unsplash.com/photo-1707333514312-39cf7658479c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxldmVudCUyMHdhcm0lMjBzdHJpbmclMjBsaWdodHMlMjB3ZWRkaW5nfGVufDB8fHx8MTc5MTM4NjQ4OXww&ixlib=rb-4.1.0&q=85",
  uplight: "https://images.unsplash.com/photo-1630458467608-003fa5af987d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwYmF0dGVyeSUyMHVwbGlnaHRpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxMzg2NDg5fDA&ixlib=rb-4.1.0&q=85",
  party: "https://images.unsplash.com/photo-1745470554004-8b55f450b528?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwYmF0dGVyeSUyMHVwbGlnaHRpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxMzg2NDg5fDA&ixlib=rb-4.1.0&q=85",
  xmasExterior: "https://images.unsplash.com/photo-1766671617424-d77a5c24de2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGNocmlzdG1hcyUyMGxpZ2h0cyUyMHdhcm0lMjBleHRlcmlvcnxlbnwwfHx8fDE3ODM3NTQzNjl8MA&ixlib=rb-4.1.0&q=85",
  xmasInterior: "https://images.unsplash.com/photo-1640505933280-82074a4836d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjaHJpc3RtYXMlMjB0cmVlJTIwbGl2aW5nJTIwcm9vbSUyMGVsZWdhbnQlMjB3YXJtJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkxMTUwNDE2fDA&ixlib=rb-4.1.0&q=85",
  xmasTree: "https://images.unsplash.com/photo-1766393030565-12f744515335?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjaHJpc3RtYXMlMjB0cmVlJTIwbGl2aW5nJTIwcm9vbSUyMGVsZWdhbnQlMjB3YXJtJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkxMTUwNDE2fDA&ixlib=rb-4.1.0&q=85",
  nutcracker: "https://images.unsplash.com/photo-1605012833863-e5771ccabae1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxudXRjcmFja2VyJTIwY2hyaXN0bWFzJTIwZGVjb3JhdGlvbnxlbnwwfHx8fDE3ODU1MzIxNzB8MA&ixlib=rb-4.1.0&q=85",
  xmasFacade: "https://images.unsplash.com/photo-1766575996280-41cc6c475c1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxob3VzZSUyMGNocmlzdG1hcyUyMGxpZ2h0cyUyMHdhcm0lMjBleHRlcmlvcnxlbnwwfHx8fDE3ODM3NTQzNjl8MA&ixlib=rb-4.1.0&q=85",
  audioColumn: "https://images.unsplash.com/photo-1666017730352-d4d273e0edd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxjb2x1bW4lMjBzcGVha2VyJTIwd2VkZGluZyUyMGV2ZW50fGVufDB8fHx8MTc5MTU2NTQzMnww&ixlib=rb-4.1.0&q=85",
  audioMic: "https://images.unsplash.com/photo-1745848413041-3eeb106db501?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwc3BlZWNoJTIwbWljcm9waG9uZSUyMHNwZWFrZXJ8ZW58MHx8fHwxNzkxNTY1NDMyfDA&ixlib=rb-4.1.0&q=85",
};

export const WHATSAPP = {
  phone: "393392793678",
  displayPhone: "+39 339 279 3678",
  message: "Ciao LMserviceevent! Vorrei informazioni e un preventivo per il noleggio e allestimento per un evento il...",
};

export const MARQUEE_ITEMS = [
  "FARI A BATTERIA WIRELESS RGBW",
  "LUMINARIE ARTIGIANALI & CATENARIE VINTAGE",
  "CIELO STELLATO & FAIRY LIGHTS",
  "ILLUMINAZIONI NATALIZIE CHIAVI IN MANO",
  "ALBERI DI NATALE & SCHIACCIANOCI A NOLEGGIO",
  "IMPIANTI AUDIO A BATTERIA & RADIOMICROFONI",
  "INSTALLAZIONE & REGIA TECNICA LUCI",
  "CERTIFICAZIONI & COLLAUDO IN LOCO",
];

export const CATEGORIES = [
  {
    id: "fari-batteria",
    label: "Fari a Batteria",
    description: "Illuminazione architetturale senza fili, autonomia fino a 8 ore, controllo DMX wireless e protezione IP65 da esterno.",
    items: [
      {
        slug: "smartbat-uplight",
        name: "SmartBAT Uplight Pro RGBW",
        badge: "Top Seller Matrimoni",
        specs: "8h autonomia • 100% Wireless • IP65 pioggia • Controllo cromatico da app",
        desc: "Ideale per valorizzare facciate di ville storiche, uliveti, chiostri e colonnati con accenti ambrati o personalizzati.",
        price: "A partire da € 25 / pezzo",
        image: IMAGES.uplight,
      },
      {
        slug: "tube-light-pixel",
        name: "Tube Light LED Pixel 360°",
        badge: "Design Scenografico",
        specs: "Effetti dinamici • Luce a 360° • Batteria integrata • Supporti terra o sospesi",
        desc: "Per party dance floor, percorsi luminosi futuristici o scenografie geometriche per photo booth.",
        price: "Su richiesta a kit",
        image: IMAGES.party,
      },
    ],
  },
  {
    id: "luminarie",
    label: "Luminarie & Catenarie",
    description: "Festone vintage in stile borgo pugliese, cieli stellati e cascate luminose per banchetti da fiaba.",
    items: [
      {
        slug: "catenaria-vintage",
        name: "Catenaria Vintage Festoon Warm 2200K",
        badge: "Must Have Estivo",
        specs: "Portalampada nero vintage • Lampadine a filamento caldo infrangibili • Modulare fino a 500m",
        desc: "Crea la classica atmosfera intima della piazza di paese, adatta per giardini e tensostrutture.",
        price: "Tariffa a metro lineare",
        image: IMAGES.festoon,
      },
      {
        slug: "cielo-stellato",
        name: "Cielo Stellato Micro-LED (Fairy Light Canopy)",
        badge: "Effetto Wow Garantito",
        specs: "Oltre 3.000 micro-punti luce • Cavo trasparente invisibile • Struttura di sostegno inclusa",
        desc: "Un tetto luminoso mozzafiato sospeso sopra il tavolo degli sposi o la zona ballo.",
        price: "Installazione chiavi in mano",
        image: IMAGES.fairyCanopy,
      },
      {
        slug: "tunnel-luce",
        name: "Tunnel & Archi di Luce Tradizionali",
        badge: "Tradizione Italiana",
        specs: "Legno laccato bianco • Lampadine passo E14 calde • Struttura portante autoportante",
        desc: "Accoglienza scenografica all'ingresso della location o corridoio per il taglio torta.",
        price: "Personalizzato su misura",
        image: IMAGES.courtyard,
      },
    ],
  },
  {
    id: "natale",
    label: "Natale",
    description: "Realizzazione di illuminazioni natalizie esterne e interne, con noleggio di decorazioni, alberi allestiti e schiaccianoci giganti.",
    items: [
      {
        slug: "illuminazione-esterna",
        name: "Illuminazione Esterna Natalizia",
        badge: "Facciate & Ville",
        specs: "Tende e cascate LED bianco caldo 2700K • Quadri e cablaggi a norma • Resistente a pioggia e gelo",
        desc: "Progettiamo e realizziamo l'illuminazione esterna di ville, agriturismi, sedi aziendali e vetrine: dal sopralluogo al collaudo finale.",
        price: "Progetto su misura",
        image: IMAGES.xmasExterior,
      },
      {
        slug: "illuminazione-interna",
        name: "Illuminazione Interna Natalizia",
        badge: "Atmosfera Calda",
        specs: "Micro-LED a basso consumo • Addobbo di sale, hall e showroom • Montaggio e smontaggio inclusi",
        desc: "Hall di hotel, ristoranti e spazi commerciali si vestono a festa con scenografie luminose calde ed eleganti, senza pensieri per lo staff.",
        price: "Preventivo in 24h",
        image: IMAGES.xmasInterior,
      },
      {
        slug: "alberi-natale-noleggio",
        name: "Alberi di Natale Decorati a Noleggio",
        badge: "Fino a 6 Metri",
        specs: "Altezze da 2 a 6 m • Decorazioni coordinate a tema colore • Consegna, allestimento e ritiro a fine stagione",
        desc: "Alberi maestosi già addobbati secondo la palette scelta: oro e champagne, rosso tradizionale o bianco ghiaccio.",
        price: "A seconda dell'altezza",
        image: IMAGES.xmasTree,
      },
      {
        slug: "schiaccianoci-decorazioni",
        name: "Schiaccianoci Giganti & Decorazioni Scenografiche",
        badge: "Effetto Wow",
        specs: "Schiaccianoci oltre 2 m • Sfere giganti, renne e pacchi regalo luminosi • Perfetti per ingressi e photo corner",
        desc: "Decorazioni scenografiche a noleggio che trasformano l'ingresso in un set fotografico per i tuoi ospiti e clienti.",
        price: "A composizione",
        image: IMAGES.nutcracker,
      },
    ],
  },
  {
    id: "audio",
    label: "Audio",
    description: "Impianti audio professionali a batteria e radiomicrofoni per cerimonie, discorsi e musica d'ambiente, senza cavi a vista.",
    items: [
      {
        slug: "colonna-battery",
        name: "Impianto Audio a Colonna Battery",
        badge: "Cerimonie & Aperitivi",
        specs: "Autonomia 8h • Bluetooth + mixer integrato • Copertura fino a 150 ospiti • Stativi inclusi",
        desc: "Colonne eleganti e discrete per musica d'ambiente, riti civili all'aperto e sottofondo durante la cena: suono uniforme, zero ingombro.",
        price: "A partire da € 80 / giorno",
        image: IMAGES.audioColumn,
      },
      {
        slug: "casse-radiomicrofoni",
        name: "Casse Attive Wireless + Radiomicrofoni",
        badge: "Discorsi & DJ Set",
        specs: "2 casse attive + 2 radiomicrofoni • Asta e gelato inclusi • Tecnico audio su richiesta",
        desc: "Per discorsi, brindisi e intrattenimento serale: voci sempre chiare e musica a tutto volume quando scende la sera.",
        price: "Su richiesta a kit",
        image: IMAGES.audioMic,
      },
    ],
  },
];

export const SERVICES = [
  {
    type: "FORNITURA DIRETTA",
    tagline: "Noleggio Puro",
    subtitle: "Per Wedding Planner, Service e Professionisti del settore",
    features: [
      "Ritiro presso nostro magazzino o consegna al piano programmata",
      "Attrezzature collaudate e pulite",
      "Fari a batteria consegnati con carica 100%",
      "Assistenza telefonica h24 durante il giorno dell'evento",
    ],
    cta: "Richiedi Listino Fornitura",
    badge: "Flessibilità Massima",
  },
  {
    type: "FORNITURA + INSTALLAZIONE",
    tagline: "Chiavi in Mano",
    subtitle: "La soluzione zero pensieri per matrimoni, eventi e allestimenti natalizi",
    features: [
      "Sopralluogo tecnico preliminare o studio planimetria location",
      "Posa in opera a regola d'arte senza fili visibili o intralci pedonali",
    ],
    cta: "Prenota Servizio Completo",
    badge: "Scelto dal 92% dei Clienti",
    featured: true,
  },
];

export const PORTFOLIO = [
  {
    title: "Cena Placée sotto Cielo Stellato a Villa Medicea",
    category: "Catenarie & Cieli Stellati",
    image: "https://images.unsplash.com/photo-1756267237113-8e51341a21ff?auto=format&fit=crop&q=85&w=1200",
    details: "800m catenarie vintage ambrate, 24 fari a batteria per viale monumentale.",
  },
  {
    title: "Illuminazione Architetturale Chiostro Storico",
    category: "Fari a Batteria",
    image: "https://images.unsplash.com/photo-1705354154972-776d658c90a9?auto=format&fit=crop&q=85&w=1200",
    details: "Uplighting su 16 colonne rinascimentali con tonalità caldo-dorata.",
  },
  {
    title: "Villa Storica Illuminata per le Feste",
    category: "Natale",
    image: "https://images.unsplash.com/photo-1766671617424-d77a5c24de2d?auto=format&fit=crop&q=85&w=1200",
    details: "Tende luminose calde sull'intera facciata e albero monumentale da 6 m nel cortile d'onore.",
  },
  {
    title: "Tensostruttura Crystal con Lampadari & Festoni",
    category: "Luminarie & Catenarie",
    image: "https://images.unsplash.com/photo-1519226612673-73c0234437ef?auto=format&fit=crop&q=85&w=1200",
    details: "Mix di sospensioni vintage e lampadari in cristallo per 180 invitati.",
  },
];

export const PILLARS = [
  {
    number: "01",
    title: "Zero Cavi a Vista",
    description: "Utilizziamo esclusivamente proiettori professionali a batteria di ultimissima generazione, preservando l'estetica delle location storiche senza cavi pericolosi sul prato o pavimentazioni di pregio.",
  },
  {
    number: "02",
    title: "Installazione Certificata",
    description: "Tutte le nostre luminarie e catenarie sono cablate a norme CE con quadri a protezione differenziale. Fissaggi di sicurezza testati contro vento e intemperie.",
  },
  {
    number: "03",
    title: "Puntualità & Pulizia Impeccabile",
    description: "Rispettiamo gli orari concordati con la location e il catering. Smontaggio silenzioso a fine evento senza lasciare tracce.",
  },
  {
    number: "04",
    title: "Preventivi Chiari Senza Sorprese",
    description: "Voci di noleggio e posa distinte e trasparenti, con sopralluogo tecnico dove necessario.",
  },
];

export const EQUIPMENT_OPTIONS = [
  "Fari a batteria wireless",
  "Luminarie & Catenarie vintage",
  "Cielo stellato fairy lights",
  "Illuminazione natalizia esterna/interna",
  "Alberi di Natale decorati a noleggio",
  "Schiaccianoci e decorazioni scenografiche",
  "Impianto audio e radiomicrofoni",
];

export const SERVICE_OPTIONS = [
  "Solo Fornitura a Noleggio (ritiro proprio)",
  "Fornitura con Consegna",
  "Fornitura + Installazione Chiavi in Mano",
];
